var nav = function(obj, _this) {
    // document.documentElement.scrollTop = window.pageYOffset = document.body.scrollTop = 0;
    $('body,html').scrollTop(0)
    _this.$router.push(obj);
}


export default {
    nav: nav
}


// WEBPACK FOOTER //
// ./src/common/js/util.js